import React, { useEffect, useState } from "react";
import { InputField1 } from "../InputField1/InputField1";
import Typography from "../Typography/Typography";
import { AddTicketStyle } from "./AddTicketStyle";
import { SimpleSelect1 } from "../SimpleSelect/SimpleSelect1";
import { SimpleTextArea } from "../SimpleTextArea/SimpleTextArea";
import { SelectMulti } from "../MultiSelect/MultiSelect";
import Button from "../Button/Button";
import { useAddTicket, useGetDepartementList } from "../../hooks/useManagement";
import { useListUser } from "../../hooks/useAccounting";
import { GrAttachment } from "react-icons/gr";
import { useNavigate } from "react-router-dom";
import { errorMessage } from "../../utils/message";
import Editor from "../../core/components/textEditor/Editor";
import { useGetCompanyUsers } from "../../hooks/useCrm";
const initvalue = {
  subject: null,
  department_id: null,
  content: null,
  file: null,
  target_user: [],
};
const AddTicket = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState(initvalue);
  const [content, setContent] = useState(null);
  const rolls = JSON.parse(localStorage.getItem("profile"));
  const roll = rolls?.users[0]?.Status;
  // const { data, isLoading, refetch } = useListUser();
  const { data, isLoading, refetch } = useGetCompanyUsers();
  const {
    data: departement,
    isLoading: DepartementLoading,
    refetch: departmentFetching,
  } = useGetDepartementList();
  useEffect(() => {
    setForm({ ...form, content: content });
  }, [content]);

  const Departements = departement?.data?.Departments;
  const DepartementOption = Departements?.map((dep) => {
    return {
      value: dep.IdDepartment,
      label: dep.NameDepartment,
    };
  });
  const { mutateAsync: AddTicket, isLoading: AddingTicket } = useAddTicket();

  const users = data?.data?.ManagersAndColleagues;
  const usersOptions = users?.map((user) => {
    return {
      value: user.IdUser,
      label:
        (user.FirstName ? user.FirstName : "") +
        " " +
        (user.LastName ? user.LastName : ""),
    };
  });

  const validateForm = () => {
    if (form.subject === null || form.subject.length < 1) {
      errorMessage("موضوع تیکت را مشخص کنید");
      return false;
    } else if (form.content === null || form.content.length < 1) {
      errorMessage("متن تیکت را بنویسید");
      return false;
    } else if (form.department_id === null || form.department_id.length < 1) {
      errorMessage("دپارتمان را انتخاب کنید");
      return false;
    } else if (form.target_user === null || form.target_user.length < 1) {
      errorMessage("شخص هدف تیکت را انتخاب کنید");
      return false;
    }
    return true;
  };

  const handleAddTicket = async () => {
    if (validateForm()) {
      const formdata = new FormData();
      formdata.append("subject", form?.subject);
      formdata.append("content", form?.content);
      formdata.append("department_id", form?.department_id);

      if (form.file) {
        formdata.append("file", form?.file);
      }
      for (var i = 0; i < form?.target_user.length; i++) {
        formdata.append(`target_user[${i}]`, form?.target_user[i]);
      }

      await AddTicket(formdata).then(() =>
        navigate("/dashboard/management/tickets/ticketsList")
      );
    }
  };
  return (
    <AddTicketStyle className="mt-3">
      <div className="row m-0 ticket-card ">
        <div className="col-12 m-0 p-0">
          <div className="header">
            <Typography>تیکت جدید</Typography>
          </div>
          <div className="body">
            <div className="row p-2">
              <div
                className="col-lg-4 col-12
                "
              >
                <InputField1
                  placeholder="موضوع تیکت"
                  label="موضوع تیکت"
                  onChange={(e) =>
                    setForm({ ...form, subject: e.target.value })
                  }
                />
              </div>
              <div className="col-lg-4 col-12">
                {roll == "admin" ? (
                  <SelectMulti
                    label="ارسال برای"
                    onMenuOpen={refetch}
                    zIndex={true}
                    res={usersOptions}
                    isLoading={isLoading}
                    loadingMessage={() => "در حال بارگزاری"}
                    onChange={(e) =>
                      setForm({
                        ...form,
                        target_user: Array.isArray(e)
                          ? e.map((x) => x.value)
                          : [],
                      })
                    }
                  />
                ) : (
                  <SimpleSelect1
                    zIndex={true}
                    label="ارسال برای"
                    onMenuOpen={refetch}
                    res={usersOptions}
                    isLoading={isLoading}
                    loadingMessage={() => "در حال بارگزاری"}
                    onChange={(e) =>
                      setForm({ ...form, target_user: [e.value] })
                    }
                  />
                )}
              </div>
              <div className="col-lg-4 col-12">
                <SimpleSelect1
                  label="انتخاب دپارتمان"
                  res={DepartementOption}
                  isLoading={DepartementLoading}
                  onMenuOpen={departmentFetching}
                  onChange={(e) => {
                    setForm({ ...form, department_id: e.value });
                  }}
                />
              </div>
              <div className="col-12 mt-3">
                {/* <SimpleTextArea
                  label="متن تیکت"
                  rows="5"
                  placeholder="متن تیکت را اینجا بنویسید"
                  onChange={(e) =>
                    setForm({ ...form, content: e.target.value })
                  }
                /> */}
                <Editor
                  state={content}
                  setState={setContent}
                  label="متن تیکت"
                />
              </div>
              <div className="col-12 d-flex">
                <Button
                  bgColor="#009ef7"
                  color="#fff"
                  small="fit-content"
                  size="14px"
                  onclick={() => handleAddTicket(form)}
                >
                  {!AddingTicket ? "ارسال تیکت" : "...در حال ارسال تیکت"}
                </Button>
                <div className="file">
                  <label htmlFor="input-file">
                    <GrAttachment />
                  </label>
                  <input
                    id="input-file"
                    type="file"
                    onChange={(e) =>
                      setForm({ ...form, file: e.target.files[0] })
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AddTicketStyle>
  );
};

export default AddTicket;
